import { render, staticRenderFns } from "./ThankYouTopper.vue?vue&type=template&id=856dbb58&scoped=true&"
import script from "./ThankYouTopper.vue?vue&type=script&lang=js&"
export * from "./ThankYouTopper.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouTopper.vue?vue&type=style&index=0&id=856dbb58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856dbb58",
  null
  
)

export default component.exports